export default "__VITE_ASSET__wkNCEd$n__"